import exportSubcontractorPdf from '../../../Services/exportSubcontractorPdf'

export default () => (dispatch) => {

  dispatch(exportSubcontractorPdf())

}
